<template>
  <div class="normal-layout">
    <media :query="{ minDeviceWidth: 1001 }">
      <div class="nav-bar-wrapper">
        <nav-bar></nav-bar>
      </div>
    </media>

    <div class="view-wrapper" id="viewwrapper">
      <router-view :key="currentData"></router-view>
    </div>
    <media :query="{ minDeviceWidth: 1001 }">
      <footer>
        <foot></foot>
      </footer>
    </media>
  </div>
</template>
<script>
import NavBar from "@/views/components/nav-bar/nav-bar";
import Foot from "@/views/components/foot/foot";
import { mapGetters } from "vuex";
import Media from "vue-media";
export default {
  data() {
    return {};
  },
  name: "App",
  components: {
    NavBar,
    Foot,
    Media
  },
  computed: {
    ...mapGetters(["currentData"])
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.normal-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.nav-bar-wrapper {
  // position: relative;
  flex: 0 0 auto;
  height: 100px;
}
.view-wrapper {
  flex: 1 0 auto;
  /*background-color: #f8fafc;*/
  background-color: #fff;
}
footer {
  // margin-top: 30px;
  flex: 0 140px auto;
  // height: 140px;
  width: 100%;
  min-width: 1260px;
  background: #f8f8f8;
  /*background-color: #fff;*/
  /*-webkit-box-shadow: 0 0 3px #eee;*/
  /*box-shadow: 0 0 3px #eee;*/
}
</style>



// WEBPACK FOOTER //
// src/views/layout/normal-layout.vue